import { IoIosHome } from "react-icons/io";
import { FaFileAlt } from "react-icons/fa";
import { FaPhotoFilm } from "react-icons/fa6";
import { FaPhotoVideo } from "react-icons/fa";
import { FaUser } from "react-icons/fa";
import { MdFactory } from "react-icons/md";

import { FaShare } from "react-icons/fa6";
import { SiQuickbooks } from "react-icons/si";
import { FaTrash } from "react-icons/fa";
import { SiVorondesign } from "react-icons/si";
import { GiGalaxy } from "react-icons/gi";
import { Home } from '@solar-icons/react';
import { File } from '@solar-icons/react';
import { History } from '@solar-icons/react'

import { LockKeyholeUnlocked } from '@solar-icons/react';
import { UsersGroupRounded } from '@solar-icons/react'
import { Star } from '@solar-icons/react'
import { UsersGroupTwoRounded } from '@solar-icons/react'
import { TrashBinTrash } from '@solar-icons/react'
import { SettingsMinimalistic } from '@solar-icons/react'
import { Videocamera } from '@solar-icons/react'
import { VolumeSmall } from '@solar-icons/react'
import { MdOutlineProductionQuantityLimits } from "react-icons/md";
import { FaPersonDigging } from "react-icons/fa6";
import { BsPersonPlus } from "react-icons/bs";

 export const top = [
   { icon: <Home />, name: 'Home', path: '/' },
  { icon: <File/>, name: 'MyDrive', path: '/myDrive' },
  { icon: <LockKeyholeUnlocked/>, name: "SafeFolder", path: "/safeFolder" },

 ]

 export const center =[
    { icon: <UsersGroupRounded/>, name: "sharewithme", path: "/sharewithme" },
{ icon: <History/>, name: "Recent", path: "/recent" },
   { icon: <Star/>, name: "Starred", path: "/starred" },
 ]


 export const centerPoint = [
    { icon: <UsersGroupTwoRounded/>, name: "Members", path: "/members" },
 ]
   
   
export const last = [
   { icon: <TrashBinTrash/>, name: "Trash", path: "/trash" },
   { icon: <SettingsMinimalistic/>, name: "Settings", path: "/settings" },
]

  
export const lastpoint =[
   /*  { icon: < File />, name: "File", path: "/fileList" },
  { icon: <Videocamera />, name: "Photos", path: "/photos" },
  { icon: < Videocamera  />, name: "Videos", path: "/videos" },
   { icon: <VolumeSmall />, name: "Audios", path: "/audios" }, */
   /* {icon: <MdOutlineProductionQuantityLimits/>, name:'Products',path:'/products'},
    {icon: <FaPersonDigging/>, name:'Employee',path:'/employee'},
    {icon:<BsPersonPlus/>, name:'Client',path:'/client'} */
]
  

  
 


